import React from "react";
const SlideNewsCom = (props) => {
  const width = document.body.clientWidth;
  return (
    <div
      className="flex justify-between flex-col items-center w-full cursor-pointer"
      onClick={props.onClick}
      style={{
        width:
          width < 500
            ? width / 2 - 10 // "90%"
            : width === 768
            ? width / 5 - 30
            : width === 1024
            ? width / 5 - 40
            : width / 5,
      }}
    >
      <div
        style={{ backgroundColor: props.bgcolor }}
        className="rounded-full p-1 lg:p-1.5 xs:w-36 xs:h-36 sm:w-28 lg:w-40 lg:h-40 xl:w-60 sm:h-28 xl:h-60"
      >
        <img
          src={props.latestNewsthubmail}
          className="w-full h-full rounded-full object-cover"
          alt={props.alt}
        />
      </div>
      <div className="flex justify-center items-start h-[25%] xs:pt-2 sm:pt-3 sm:pb-2 xs:pb-4 lg:pt-4">
        <div className="lg:max-w-56">
          <p className="uppercase text-secondary font-onestBold xs:text-sm line-clamp-2 sm:text-base xs:leading-4 lg:text-lg xl:text-xl text-center">
            {props.latestNewsTitle}
          </p>
          <p className="uppercase text-secondary font-onestRegular xs:text-xs sm:text-sm xs:leading-4 lg:text-base text-center">
            {props.position}
          </p>
        </div>
      </div>
    </div>
  );
};
export default SlideNewsCom;
